export default {
    name: 'Configuration',
    data() {
        return {
            formBonus: this.$form.createForm(this, { name: 'Form Bonus' }),
            formOvertime: this.$form.createForm(this, { name: 'Form Overtime' }),
            fieldsLabelOT: [],
            fieldsLabelBonus: [],
            isEdit: false,
            size: window.outerWidth > 1000 ? window.outerWidth * 0.6 : window.outerWidth * 0.55,
            timeout: null,
        }
    },
    created() {
        this.getAllConfigTable()
        window.addEventListener('resize',this.resize)
    },
    methods: {
        resize(){
            if (document.body.clientWidth > 1000) {
                this.size = document.body.clientWidth * 0.6
            } else {
                this.size = document.body.clientWidth * 0.55
            }
        },
        getAllConfigTable() {
            this.$store.dispatch('user/loadingRequest');
            this.$store.dispatch("configuration/getConfigTableAll").then(res => {
                if(res && res.data) {
                    let findConfigOT = res.data.find(
                        item => item.table_code === 'payroll_overtime'
                    )
                    if(findConfigOT) {
                        for(let element of findConfigOT.table_config) {
                            if(element.key === 'coefficient_workday') {
                                this.formOvertime.setFieldsValue({coefficient_workday: element.value})
                            }
                            if(element.key === 'coefficient_night_workday') {
                                this.formOvertime.setFieldsValue({coefficient_night_workday: element.value})
                            }
                            if(element.key === 'coefficient_night_workday_has_day_time') {
                                this.formOvertime.setFieldsValue({coefficient_night_workday_has_day_time: element.value})
                            }
                            if(element.key === 'coefficient_day_off') {
                                this.formOvertime.setFieldsValue({coefficient_day_off: element.value})
                            }
                            if(element.key === 'coefficient_night_day_off') {
                                this.formOvertime.setFieldsValue({coefficient_night_day_off: element.value})
                            }
                            if(element.key === 'coefficient_holiday') {
                                this.formOvertime.setFieldsValue({coefficient_holiday: element.value})
                            }
                            if(element.key === 'coefficient_night_holiday') {
                                this.formOvertime.setFieldsValue({coefficient_night_holiday: element.value})
                            }
                            if(element.key === 'tax_coefficient_workday') {
                                this.formOvertime.setFieldsValue({tax_coefficient_workday: element.value})
                            }
                            if(element.key === 'tax_coefficient_night_workday') {
                                this.formOvertime.setFieldsValue({tax_coefficient_night_workday: element.value})
                            }
                            if(element.key === 'tax_coefficient_day_off') {
                                this.formOvertime.setFieldsValue({tax_coefficient_day_off: element.value})
                            }
                            if(element.key === 'tax_coefficient_night_day_off') {
                                this.formOvertime.setFieldsValue({tax_coefficient_night_day_off: element.value})
                            }
                            if(element.key === 'tax_coefficient_holiday') {
                                this.formOvertime.setFieldsValue({tax_coefficient_holiday: element.value})
                            }
                            if(element.key === 'tax_coefficient_night_holiday') {
                                this.formOvertime.setFieldsValue({tax_coefficient_night_holiday: element.value})
                            }
                        }
                        delete findConfigOT.id
                        this.fieldsLabelOT = findConfigOT
                    }
                    let findConfigBonus = res.data.find(
                        item => item.table_code === 'bonus'
                    )
                    if(findConfigBonus) {
                        for(let element of findConfigBonus.table_config) {
                            if(element.key === 'Staff') {
                                this.formBonus.setFieldsValue({Staff: element.value})
                            }
                            if(element.key === 'Management') {
                                this.formBonus.setFieldsValue({Management: element.value})
                            }
                            // this.formBonus[element.key] = element.value
                        }
                        delete findConfigBonus.id
                        this.fieldsLabelBonus = findConfigBonus
                    }
                }
                this.$store.dispatch('user/loadingRequest');
            }).catch(error => {
                this.$message.error(error.message, 5);
                this.$store.dispatch('user/loadingRequest')
            })
        },
        onChangeValueOvertime(value, name) {
            // this.fieldsLabelOT.table_config.forEach(item => {
            //     if(item.key === name) {
            //         if(value.target.value === '' || value.target.value === null) {
            //             item.value = 0
            //         }
            //         else {
            //             if(isNaN(parseInt(value.target.value))) {
            //                 this.$message.error('Value is not a number')
            //                 this.isEdit = false
            //             } else {
            //                 item.value = parseInt(value.target.value)
            //                 this.isEdit = true
            //             }
            //         }
            //     }
            // })
            this.onchangeValue(this.fieldsLabelOT, value, name)
        },
        onChangeValueBonus(value, name) {
            // this.fieldsLabelBonus.table_config.forEach(item => {
            //     if(item.key === name) {
            //         if(value.target.value === '' || value.target.value === null) {
            //             item.value = 0
            //         }
            //         else {
            //             if(isNaN(parseInt(value.target.value))) {
            //                 this.$message.error('Value is not a number')
            //                 this.isEdit = false
            //             } else {
            //                 item.value = parseInt(value.target.value)
            //                 this.isEdit = true
            //             }
            //         }
            //     }
            // })
            this.onchangeValue(this.fieldsLabelBonus, value, name)
        },
        onchangeValue(fieldLabel, value, name){
            fieldLabel.table_config.forEach(item => {
                if(item.key === name) {
                    if(value.target.value === '' || value.target.value === null) {
                        item.value = 0
                    }
                    else {
                        if(isNaN(parseInt(value.target.value))) {
                            this.$message.error('Value is not a number')
                            this.isEdit = false
                        } else {
                            item.value = parseInt(value.target.value)
                            this.isEdit = true
                        }
                    }
                }
            })
        },
        handleSubmitConfig(e) {
            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
                e.preventDefault();
                var payload = [];
                this.formOvertime.validateFields((err) => {
                    if(!err) {
                        payload.push(this.fieldsLabelOT)
                    }
                })
                this.formBonus.validateFields((err) => {
                    if(!err) {
                        payload.push(this.fieldsLabelBonus)
                    }
                })
                if(this.isEdit) {
                    this.$store.dispatch('configuration/updateConfigTableAll',payload ).then(res => {
                        if(parseInt(res.code) === 0) {
                            this.$message.success(res.message, 5)
                            this.getAllConfigTable()
                        } else {
                            this.$message.error(res.message, 5)
                        }
                    }).catch(error => {
                        this.$message.error(error.message, 5)
                        this.$store.dispatch('user/loadingRequest')
                    })
                } else {
                    this.$message.error('Update Fail', 5)
                }
            }, 500)
        },
    },
}
